import { render, staticRenderFns } from "./auction-imgs-overlay.vue?vue&type=template&id=0cbcdaf4&"
import script from "./auction-imgs-overlay.vue?vue&type=script&lang=js&"
export * from "./auction-imgs-overlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports